export default function GameHeader({ event, scores, context }) {
  const gameTime = new Date(event.commence_time).toLocaleString('en-US', {
    weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  });

  const homeScore = scores?.scores?.find((s) => s.name === event.home_team);
  const awayScore = scores?.scores?.find((s) => s.name === event.away_team);
  const hasScores = homeScore?.score != null && awayScore?.score != null;
  const isLive = hasScores && !scores?.completed;
  const isFinal = hasScores && scores?.completed;

  const homeRecord = context?.home_record || null;
  const awayRecord = context?.away_record || null;
  const homeLogo = context?.home_logo || null;
  const awayLogo = context?.away_logo || null;
  const homeColor = context?.home_color || null;
  const awayColor = context?.away_color || null;

  return (
    <div className="relative rounded-lg border border-[#E5E7EB] dark:border-[#1e2536] bg-white dark:bg-[#151a25] px-6 py-5 overflow-hidden" style={{ fontFamily: 'var(--font-sans)' }}>
      {/* Color accent gradients */}
      {awayColor && (
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: `linear-gradient(to right, #${awayColor}1a 0%, transparent 45%)` }}
        />
      )}
      {homeColor && (
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: `linear-gradient(to left, #${homeColor}1a 0%, transparent 45%)` }}
        />
      )}

      <div className="relative flex items-center justify-between">
        {/* Away team */}
        <div className="flex flex-1 min-w-0 items-center gap-3">
          {awayLogo && (
            <img
              src={awayLogo}
              alt=""
              className="w-14 h-14 object-contain flex-shrink-0"
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          )}
          <div className="min-w-0">
            <p className="text-[20px] font-bold text-[#111827] dark:text-[#e2e8f0] leading-tight">{event.away_team}</p>
            {awayRecord && <p className="text-[14px] text-[#6B7280] dark:text-[#8892a8] mt-0.5">{awayRecord}</p>}
          </div>
        </div>

        {/* Center — score or game info */}
        <div className="flex flex-col items-center px-6 flex-shrink-0">
          {/* Sport badge */}
          <span className="text-[11px] font-semibold uppercase tracking-wide px-2.5 py-0.5 rounded-full bg-[#005BB3] text-white mb-2">
            {event.sport_title}
          </span>

          {hasScores ? (
            <>
              <div className="flex items-center gap-3">
                <span className="text-[28px] font-bold text-[#111827] dark:text-[#e2e8f0]" style={{ fontFamily: 'var(--font-mono)' }}>{awayScore.score}</span>
                <span className="text-[14px] text-[#9CA3AF] dark:text-[#505a6e]">-</span>
                <span className="text-[28px] font-bold text-[#111827] dark:text-[#e2e8f0]" style={{ fontFamily: 'var(--font-mono)' }}>{homeScore.score}</span>
              </div>
              {isLive && (
                <span className="text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#DC2626] text-white mt-1">Live</span>
              )}
              {isFinal && (
                <span className="text-[12px] font-medium text-[#6B7280] dark:text-[#8892a8] mt-1">Final</span>
              )}
            </>
          ) : (
            <>
              <p className="text-[16px] font-medium text-[#6B7280] dark:text-[#8892a8] my-1">@</p>
              <p className="text-[14px] text-[#6B7280] dark:text-[#8892a8]">{gameTime}</p>
            </>
          )}
        </div>

        {/* Home team */}
        <div className="flex flex-1 min-w-0 items-center justify-end gap-3">
          <div className="min-w-0 text-right">
            <p className="text-[20px] font-bold text-[#111827] dark:text-[#e2e8f0] leading-tight">{event.home_team}</p>
            {homeRecord && <p className="text-[14px] text-[#6B7280] dark:text-[#8892a8] mt-0.5">{homeRecord}</p>}
          </div>
          {homeLogo && (
            <img
              src={homeLogo}
              alt=""
              className="w-14 h-14 object-contain flex-shrink-0"
              onError={(e) => { e.currentTarget.style.display = 'none'; }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
